
import React, { useState } from 'react';
import { DatabaseIcon, GoogleIcon } from '../Icons';

export const LeadFinderModeModal = ({
  isOpen,
  onClose,
  onRun,
  defaultQuery = '',
}: {
  isOpen: boolean;
  onClose: () => void;
  onRun: (mode: 'database' | 'web', query: string) => void;
  defaultQuery?: string;
}) => {
  const [query, setQuery] = useState(defaultQuery);

  if (!isOpen) return null;

  const start = (mode: 'database' | 'web') => {
    onRun(mode, query.trim());
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <h3 className="text-lg font-bold text-slate-900">Waar zoek je naar?</h3>
        <p className="mt-1 text-xs text-slate-500">
          Beschrijf in één of twee zinnen wie je zoekt. Dit is wat er daadwerkelijk gezocht wordt.
        </p>

        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          rows={4}
          placeholder="Bijv. muzikanten en bands in Nederland die een bassist zoeken voor live optredens"
          className="mt-4 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
        />

        <div className="mt-4 space-y-3">
          <button
            onClick={() => start('web')}
            disabled={query.trim().length < 3}
            className="w-full p-4 border border-slate-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 text-left flex items-center gap-3 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          >
            <div className="p-2 bg-slate-100 rounded text-slate-600"><GoogleIcon /></div>
            <div>
              <div className="font-bold text-slate-800">Live websearch</div>
              <div className="text-xs text-slate-500">Zoekt echte bedrijven en websites op het internet</div>
            </div>
          </button>

          <button
            onClick={() => start('database')}
            className="w-full p-4 border border-slate-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 text-left flex items-center gap-3 transition-colors"
          >
            <div className="p-2 bg-slate-100 rounded text-slate-600"><DatabaseIcon /></div>
            <div>
              <div className="font-bold text-slate-800">Interne database / CSV</div>
              <div className="text-xs text-slate-500">Alleen de bedrijven die je zelf hebt geïmporteerd</div>
            </div>
          </button>
        </div>

        <button onClick={onClose} className="mt-4 w-full py-2 text-sm text-slate-500 hover:text-slate-800">
          Annuleren
        </button>
      </div>
    </div>
  );
};
